import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const Team = () => {
  const [speakers, setSpeakers] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("keynote_speakers");
      setSpeakers(response.results[0]?.data.collection); // Accessing the first result's collection directly
    };
    fetchData();
  }, []);

  if (!speakers) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div
      id="rs-team3"
      className="rs-team images-overlay bg5 rs-team2 pt-100 pb-70"
    >
      <div className="container">
        <div className="sec-title3 text-center transparent">
          <span>Speakers</span>
          <h2>Keynote Speakers</h2>
        </div>
        <div className="d-flex flex-row justify-content-center flex-wrap">
          {speakers?.map((speaker, index) => (
            <div className="col-md-3 text-center p-3" key={index}>
              <div className="border-0">
                <img
                  src={speaker?.image?.url}
                  alt={speaker?.name?.[0]?.text}
                  className="card-img-top img-fluid"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
                <div className="mt-2 text-white">
                  <h4 className="text-white mb-2 font-weight-bold">
                    {speaker?.name?.[0]?.text}
                  </h4>
                  <p className="card-text">{speaker?.designation?.[0]?.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
